<template>
  <div>
    <h2 class="center">{{titleWord}}</h2>
    <div class="center" v-bind:style="barStyle" />
    <h3 class="center">{{subMessage}}</h3>
  </div>
</template>
<script>
export default {
  name: "Title",
  props: {
    titleWord: String,
    subMessage: String,
    barColor: String
  },
  data: function() {
    return {
      barStyle: {
        width: "300px",
        height: "3px",
        backgroundColor: this.barColor
      }
    };
  }
};
</script>
<style scoped>
h2 {
  font-weight: normal;
  font-size: 3.75em;
  margin-top: 0px;
  margin-bottom: 40px;
}
h3 {
  font-weight: normal;
  font-size: 2.25em;
  margin-top: 25px;
  margin-bottom: 0px;
}
</style>